import React from 'react';
import BaseType from './BaseType';

const Viewed = ({ item }) => {
  return (
    <BaseType
      url={item.metadata?.known_org?.logo_url}
      name={item.metadata?.known_org?.name}
      tagType='semi-positive'
      tagText={
        <>
          💬&nbsp;&nbsp;<b>{item?.metadata?.prospect?.name}</b> Opened
        </>
      }
      tagTo={`/prospect/${item?.metadata?.prospect?.id}`}
      time={item.time}
      conversationId={item.id}
    />
  );
};

export default Viewed;
